
import AdsApi from '../libs/ads-request/ads-api';
import _const from '../const';
import { downloadFile, validateAccess } from '../libs/helpers';
import Contact from './ContactComponent.vue';

export default {
  name: 'ReceptionComponent',
  components: {
    Contact,
  },
  data: () => ({
    isExpandedPersonalInformation: true,
    isExpandedVehicleInformation: true,
    orderInfo: {},
    total: 0,
    orderActual: '',
    customerAddress: '',
    userData: null,
  }),
  computed: {
    isPaymentEnabled() {
      return validateAccess(_const.MODULE_PAYMENT);
    },
    isInvoiceEnabled() {
      return validateAccess(_const.MODULE_INVOICES);
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    phoneCustomerNumber() {
      if (this.$session.get('customerPhone')) {
        return `(${this.$session.get('customerPhone').slice(0, 3)}) ${this.$session.get('customerPhone').slice(3, 10)}`;
      }

      return 'S/R';
    },
    existContactData() {
      return this.$session.get('nameContact') !== '';
    },
  },
  mounted() {
    const order = this.$session.get('orders');
    this.orderActual = order[0].orderIdDMS;
    if (this.existContactData) {
      this.setContactData();
    } else {
      this.setCustomerData();
    }
    this.setCustomerAddress();
  },
  methods: {
    downloadPDFStatus() {
      this.loaderShow('Descargando PDF');
      AdsApi.getReceptionPdf(this.orderInfo.order_id)
        .then((response) => {
          const { data } = response;

          downloadFile(data.file, `${data.nameFile}.${data.extension}`, data.mime);
        })
        .catch((err) => this.alertShow(err, 'error'))
        .then(this.loaderHide);
    },
    setCustomerData() {
      this.userData = {
        name: this.$session.get('customerName') || 'S/R',
        tel: this.phoneCustomerNumber,
        email: this.$session.get('email') || 'S/R',
      };
    },
    setContactData() {
      this.userData = {
        name: this.$session.get('nameContact') || 'S/R',
        tel: this.$session.get('cellphoneContact') || 'S/R',
        email: this.$session.get('emailContact') || 'S/R',
      };
    },
    setCustomerAddress() {
      if (this.$session.get('customerAddress')) {
        this.customerAddress = this.$session.get('customerAddress').replace(/[^a-zA-ZÀ-ÿ0-9_]/g, ' ');
      } else {
        this.customerAddress = 'S/R';
      }
    },
  },
};
